module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipExpir"
  }, [_c('titles'), _vm._v(" "), _c('headers', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }), _vm._v(" "), _c('my-privileges', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    },
    on: {
      "showDialog": _vm.showDialog,
      "showCompensateDialog": _vm.showCompensateDialog,
      "showAuthDialog": _vm.showAuthDialog
    }
  }), _vm._v(" "), _c('job-analysis', {
    attrs: {
      "vipState": _vm.vipState
    },
    on: {
      "showDialog": _vm.showDialog
    }
  }), _vm._v(" "), _c('footers'), _vm._v(" "), _c('help'), _vm._v(" "), (_vm.show === true) ? _c('BuyDialog', {
    attrs: {
      "cardChoose": _vm.cardChoose
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "showHyxy": _vm.showHyxyDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTbts) ? _c('TbtsDialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAuth) ? _c('AuthDialog', {
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExpri === true) ? _c('ExpriDialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "buyDialog": _vm.showDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHyxy) ? _c('hyxy-dialog', {
    attrs: {
      "stopPrevent": false
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20896f6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/app/VipExpir.vue
// module id = axTv
// module chunks = 1